import { IngredientKind } from '@sg/graphql-schema';

import { type GroupedModifierItem } from '../useLineItemModifierIngredients.types';

// ─────────────────────────────────────────────────────────────────────────────

export function getDetailsKey(group: GroupedModifierItem): string {
  const hasPortions = group.count > 1;
  const hasCost = group.cost > 0;

  if (hasPortions && hasCost) return 'portionAndCost';
  if (hasPortions) return 'portionOnly';
  if (hasCost) return 'costOnly';

  return 'none';
}

export function toIngredientKind(kind: string | null | undefined): IngredientKind | null {
  if (!kind) return null;

  const values = Object.values(IngredientKind) as string[];

  return values.includes(kind) ? (kind as IngredientKind) : null;
}

export function capitalizeFirstLetter(text: string): string {
  if (text.length === 0) return text;

  return text.charAt(0).toUpperCase() + text.slice(1);
}
